import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { dashboardService } from '@/services/dashboardService';

export function useDashboardStats() {
  return useQuery({
    queryKey: queryKeys.dashboard.stats(),
    queryFn: () => dashboardService.getStats(),
  });
}

/**
 * Admin-only dashboard stats (revenue/SLA aggregates). The endpoint is gated
 * server-side by `[Authorize(Roles = "Admin")]`, so non-Admin users get a 403
 * that would surface as a spurious global error toast. Pass `enabled=false`
 * (i.e. when the user is not an Admin) to skip the fetch entirely.
 */
export function useAdminDashboardStats(enabled = true) {
  return useQuery({
    queryKey: queryKeys.dashboard.adminStats(),
    queryFn: () => dashboardService.getAdminStats(),
    enabled,
    retry: false, // Non-admin users get 403; don't retry
  });
}
